import {VscAdd} from 'react-icons/vsc';
import {IoIosCloseCircleOutline} from 'react-icons/io';
import {useForm} from "react-hook-form";
import {useToasts} from "react-toast-notifications";
import fecth from "isomorphic-fetch";
import {useState, useEffect} from "react";
import {useRouter} from "next/router";


const cartDiscount = ({coupon, subtotal})=>{
    const [messageError, setMessageError] = useState(null);
    const [couponApplied, setCouponApplied] = useState(null);
    const router = useRouter();
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = useForm();
    const { addToast } = useToasts();
    useEffect(()=>{
        if(couponApplied){
            const res = fecth('/api/coupon-add', {
                body: JSON.stringify({
                    coupon:  couponApplied
                }),
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST'
            })
                .then(d=>{
                    router.push('/compra');
                })
                .catch(e=>{
                    addToast('Ha ocurrido un error al aplicart el cupón', { appearance: 'warning', autoDismiss: true });
                })
        }
    }, [couponApplied]);
    const doCoupon = async ()=>{
        const res = await fecth('/api/coupon', {
            body: JSON.stringify({
                coupon:  event.target.coupon.value
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });
        const resJSON = await res.json();
        if(resJSON.message){
            setMessageError(resJSON.message);
        }else{
            setMessageError(null);
            if(resJSON.activo){
                if(resJSON?.amount_min > 0 && subtotal >= resJSON.amount_min){
                    setCouponApplied(resJSON.codigo);
                }else{
                    setMessageError(`Para usar este cupón necesita tener $${resJSON.amount_min} en productos`);
                }
            }else{
                setCouponApplied(null);
                setMessageError('El cupón que quieres aplicar ya no está activo');
            }
        }
        return resJSON;
    };
    const handleRemoveCoupon = async ()=>{
        const res = await fecth('/api/coupon-remove', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });
        const resJSON = await res.json();
        router.push('/compra');
        setCouponApplied(null);
    };
    const msg = (errors?.coupon?.message) ? errors?.coupon?.message : (messageError) ? messageError : ''
    if(coupon){
        return  <div className="cartDiscount marginBottom">
            <div className="cartDiscountWrapper">
                <div className="cartDiscountApplied">
                    <span><b>Cupón:</b>{coupon.code}</span>
                    <button onClick={e=> handleRemoveCoupon() }>
                        <IoIosCloseCircleOutline/>
                    </button>
                </div>
            </div>
        </div>
    }else{
        return <div className="cartDiscount marginBottom">
            <div className="cartDiscountWrapper">
                <form onSubmit={handleSubmit(doCoupon)} >
                    { (msg) && <div className="cartDiscountMsg">{msg}</div> }
                    <div className="cartDiscountInput">
                        <input type="text" placeholder="Introduce tu Cupón" autoComplete="off"
                               {...register('coupon', {
                                   required: { value: true, message: 'Escribe tu cupón' }
                               })}
                        />
                        <button>
                            <VscAdd/>
                            <span>Aplicar</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    }

};
export default cartDiscount;